import { render } from "./App.vue?vue&type=template&id=106cb7a7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=106cb7a7&lang=css"
import "./App.vue?vue&type=style&index=1&id=106cb7a7&lang=css"

import exportComponent from "/data03/virt76591/domeenid/www.kuulsaal.ee/bookings-frontend/git/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__